module.exports = {"title":"Hæfni","cards":{"Card1":{"title":"Chess Competency","button":"Sjá nánar","subtitle":"Stórmeistari í skák <br/> ELO 2580 FIDE <br/> Heimsmeistari unglinga í skák"},"Card2":{"title":"Skákþjálfara hæfni","button":"Sjá nánar","subtitle":"Hef þjálfan marga af efnilegustu skákmönnum landsins ásamt því að þjálfa í Bandaríkjunum og í Þýskalandi. <br/> FIDE Senior Trainer <br/> Þýskur A-Trainer"}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/grandmaster/is/grandmaster.yml
// module id = 947
// module chunks = 164132029939027